import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

((Drupal, once) => {

  'use strict';

  const cookie_category_id = 'embed_video';
  const plyrSelector = '.plyr--wrapper';
  const defaultOptions = {
    youtube: {
      noCookie: true,
    },
    autoplay: true,
    settings: [],
  }

  const initPlyr = (wrapper, options) => {
    new Plyr(wrapper, {...defaultOptions, ...options});
  }

  const initPlayer = (wrapper, options = {})  => {
    if(LC.cookie && !LC.cookie.isAccepted(cookie_category_id)) {
      LC.cookie.callbackAfterConsentGiven(() => initPlyr(wrapper, options), cookie_category_id);
    } else {
      initPlyr(wrapper, options);
    }
  }

  Drupal.behaviors.LcEmbedVideo = {

    attach: context => {

      // Default embedded videos.
      once('lc-embed-video', context.querySelectorAll('.plyr--embed-player')).forEach(item => {
        const wrapper = item.querySelector(plyrSelector);
        wrapper.addEventListener('click', () => initPlayer(wrapper));
      });

      // Videos that are embedded inside modal (photoswipe).
      once('lc-embed-video', context.querySelectorAll('.plyr--autoplay')).forEach(item => {
        initPlayer(item.querySelector(plyrSelector));
      });

    }
  }

})(Drupal, once);
